export function OnboardingFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/onboarding-filled.svg'"></ng-include>`
    }
}